import { Box } from 'components/ui';
import styled from 'styled-components';

export const LogoBox = styled(Box)`
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: inline-block;
  }

  &.menu {
    &:hover {
      cursor: pointer;

      img {
        opacity: 0.7;
      }
    }
  }
`;

export const CircleBox = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  background-color: ${(props) => props.$bg};
  color: ${(props) => props.$fg};
`;
